import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import * as inventoryTypeAdminService from "../../../api/admin/inventory/inventoryType";
import * as inventoryTypeService from "../../../api/vessel/inventory/inventoryType";
import { VesselContext } from "../../../routes/vessel/VesselRoot";
import wordUtils from "../../../utils/wordUtils";
import { CustomSelect, OptionItem } from "../../form/CustomSelect";
import { Word } from "../../lang/Word";
import Image from "../../media/Image";
import { Text } from "../../typography/Text";

const msgKey = "inventoryTypeSelect";

export const InventoryTypeSelect = ({ value, onChange, onCreate }) => {
    const { vessel } = useContext(VesselContext);
    const intl = useIntl();
    const [typeList, setTypeList] = useState(null);

    useEffect(() => {
        if (vessel) {
            inventoryTypeService.getTypeList({ vesselId: vessel.id }).then((response) => {
                setTypeList(wordUtils.sortListByWord(response, "name", intl.locale));
            });
        } else {
            inventoryTypeAdminService.getTypeList().then(setTypeList);
        }
    }, [vessel, intl.locale]);

    return (
        <CustomSelect
            busy={!typeList}
            value={value}
            onChange={onChange}
            isSearchable
            isClearable
            placeholder={<FormattedMessage id={`${msgKey}.selectType`} />}
            noOptionsMessage={({ inputValue }) =>
                onCreate ? (
                    <OptionItem
                        symbol={<Image size="fit" icon="plus-small" iconColor="success" />}
                        label={
                            <FormattedMessage
                                id={`${msgKey}.createNewType`}
                                values={{ name: <strong>{inputValue}</strong> }}
                            />
                        }
                        onClick={() => onCreate(inputValue)}
                    />
                ) : (
                    <FormattedMessage id={`${msgKey}.noResults`} />
                )
            }
            filterOption={(option, searchTerm) => {
                if (!searchTerm || !searchTerm.length) return true;
                const typeEntry = typeList.find((t) => t.id === option.value);
                if (!typeEntry) return false;
                const typeString = (wordUtils.formatToString(typeEntry.name) ?? "").toLowerCase();
                const categoryString = typeEntry.category
                    ? (wordUtils.formatToString(typeEntry.category.name) ?? "").toLowerCase()
                    : "";
                return (
                    typeString.includes(searchTerm.toLowerCase()) ||
                    categoryString.includes(searchTerm.toLowerCase()) ||
                    (typeEntry.keywords?.join(" ").toLowerCase().includes(searchTerm.toLowerCase()) ?? false)
                );
            }}
        >
            {typeList?.map((entry) => (
                <OptionItem
                    key={entry.id}
                    value={entry.id}
                    symbol={<Image size="fit" src={entry.picture?.url} icon="tools" />}
                    label={<Word data={entry.name} />}
                    description={
                        entry.category ? (
                            <Text block size="small" color="base40">
                                <Word data={entry.category.name} />
                            </Text>
                        ) : entry.customOnVessel ? (
                            <Text block size="small" color="base40">
                                <FormattedMessage id={`${msgKey}.custom`} />
                            </Text>
                        ) : null
                    }
                />
            ))}
        </CustomSelect>
    );
};
